import Glide from '@glidejs/glide';

function ModuleStaffMembers(container) {
	this.container = container;

	this.glide = new Glide(this.container, {
		animationDuration: 500,
		gap: 50,
		bound: true,
		peek: 20,
		perView: 4,
		breakpoints: {
			500: {
				perView: 1,
				peek: 10
			},
			800: {
				perView: 2
			},
			1000: {
				perView: 3,
				peek: 20
			},
		}
	});

	this.activateSlider();
}

ModuleStaffMembers.prototype.activateSlider = function() {
	this.glide.mount();
}

export default ModuleStaffMembers;